import React from 'react';
import { Navbarhead } from '../../components/Navbar/Navbar';
import Principal from '../../utils/images/g9.JPG'
import President from  '../../utils/images/SukPresident.jpg';
import Secretary from '../../utils/images/Mohar.jpg'
import Chairman from '../../utils/images/tressurer.png'
import { Link } from 'react-router-dom';


function Management() {
  return (
    <div className='about-page'>
    <Navbarhead/>
    <div className='container '>
    <div className="row" style={{paddingBottom:"2px"}}>
			<div className="col-md-12 text-center" style={{paddingBottom:"2px"}}>
				<div className="about_title" style={{paddingBottom:"2px"}}>
					<h2>Management</h2>
				</div>
			</div>
		</div>
        <div className="row mb-5">
    
<div className='col-lg-4 d-flex mt-5 justify-content-center order-1 order-lg-1'>
                    <img src={President} style={{width:"300px", height:"300px"}}  alt="" />
                </div>
                <div className='col-lg-8 d-flex flex-column  mb-4 mb-lg-0 order-2 order-lg-2'>
   
            <div className='ml-3   container h-100 d-flex flex-column  mt-5 text-dark'>
                <h3 className=' fw-semibold'>Dear Friends,</h3>
                <p className='mb-3'>Indian culture creates unity in diversity and the confluence of education and service is the ideal of Indian culture. We can see Indian culture only through the mirror of education. We can get rid of the poison of selfishness and ego only through education. Therefore, by drinking the nectar of knowledge and leading a life of service, make your life meaningful and provide progress to the society.
Vidya's feet start moving forward on their own to pick up the fallen, move the fallen and embrace the victim. </p>
<p className='mb-3'> According to Shri Guru Nanak Dev Ji, serving others is the greatest service. Therefore, adopting his ideals, the organization, with a spirit of service, is functional for the last four decades. Morality, discipline, tolerance, secularism are the pillars of this institution and due to which it is continuously moving on the path of progress.
With best wishes from the entire school family</p>
<p style={{fontWeight:"bold"}}>Sukhvinder Singh Lalgharia,
President </p></div>

</div>
</div>
            <div className="row mb-5">
                <div className='col-lg-8 d-flex flex-column  mb-4 mb-lg-0 order-2 order-lg-1'>
   
            <div className='ml-3   container h-100 d-flex flex-column  mt-5  text-dark'>
                <h3 className=' fw-semibold'>Dear Students,</h3>
                <p className='mb-3'>
​Educated man is an asset to the society. He can be a harbinger of social, economics and ethical change. The time after plus two is the most crucial phase in the life of a student. It can be a turning point in his career. Higher Education can transform his life. The diligent efforts put in by the student at this point of time will help him reap life long benefits.
</p>
<p className='mb-3'>
​Khalsa Girls college with its year long history, has been one of the premier Higher Educational Institutions SGNR . The Status of Autonomous College is yet another milestone achievement in its illustrious and glorious history. It is a multi-faculty Graduate Girls College, that runs degree courses at Graduate.
He mission and objective of its founding fathers has always been to inculcate high moral values along with academic excellence. To promote development of all round personality in a student, the college offers extra mural and co-curricular activities. The college has evolved a beings and benevolent system to look into the needs and problems of the students. It is expected of the students that they go through the ‘Prospectus’ thoroughly and become aware of the high ideals to make Khalsa Girls College, Sadulshahar a destination for Higher Education and Learning.
​Best wishes and blessings to the students for the upcoming session and their bright future.</p>
<p style={{fontWeight:"bold"}}>
Mohar Singh Sidhu,
Secretary </p></div>

</div>
<div className='col-lg-4 d-flex justify-content-center mt-5 order-1 order-lg-2'>
                    <img src={Secretary} style={{width:"300px", height:"300px"}}  alt="" />
                </div>
</div>
<div className="row mb-5">
    
<div className='col-lg-4 d-flex mt-5 justify-content-center order-1 order-lg-1 '>
                    <img src={Chairman} style={{width:"300px", height:"300px"}} alt="" />
                </div>
                <div className='col-lg-8 d-flex flex-column   mb-lg-0 order-2 order-lg-2'>
   
            <div className='ml-3   container h-100 d-flex flex-column mt-5   text-dark'>
                <h3 className=' fw-semibold'>Dear Friends,</h3>
                <p className='mb-3'>You are heartily welcome to Khalsa Girls College. Inspired by the saying that wealth of education increases by sharing, the college was earlier established as Khalsa Model Primary School to enrich this area with wealth of knowledge.     </p>
                <p className='mb-3'>
                Whenever I have made proposals for the progress and investigation of the organization, the management committee has encouraged me by accepting them, for which I am deeply grateful.
                  </p>
                  <p className='mb-3'>
                  Considering the spread of education and the need of the area, the school was upgraded to high school level and then to higher secondary. Due to phased development, this institution, not only in Sadulshahar, but among the leading institutions of Rajasthan, holds a special place.
                   </p>
                  <p className='mb-3'>
                  In the institution, efforts are made for the all-round development of the personality of the students and all efforts are made in such a direction that the students can find the path to their progress by adopting social diversities in practical life. I am sure that you will have all the necessary facilities available in the institution and you will get a suitable environment for study and contemplation. With best wishes for your bright future...
                   </p>
<p style={{fontWeight:"bold"}}>Sukhvinder Kaur Sidhu,
Chairman/Manager </p></div>

</div>
</div>

<div className="row mb-5">
    
    
                    <div className='col-lg-8 d-flex flex-column   mb-lg-0 order-2 order-lg-1'>
       
                <div className='ml-3   container h-100 d-flex flex-column mt-5   text-dark'>
                    <h3 className=' fw-semibold'>Dear Students,</h3>
                    <p className='mb-3'>Education is a life-long learning process. Learning happens all the time; not only in a pre-designated place called the school. It happens in the home, between home and school too. The home’s and school’s mission therefore is to provide a learning environment and opportunities to the children as the learners.   Shaping young, impressionable minds is one of life’s biggest challenges. At KHALSA GIRLS COLLEGE,SADUL SHAHAR , we aim to empower our students to grow as individuals with strong open discerning minds with an international perspective, preparing them to make a mark in the global village - the world has come to be today.</p>
                <p className='mb-3'>Our distinctive academic programmmes and innovative teaching methodologies encourage students to develop critical-thinking and learn through enquiry and reason, to exchange thoughts and ideas, to develop key personal and social values, to take ownership for her choices and to set goals to realize their own unique potential.   Authentic education implies an on-going, continuous interplay between the five moments of context, experience, reflection, action and evaluation between parents, students and lecturers.This is not to lead to mere information but to appropriation, integration into the very activity of Almighty within the created reality of our world but especially within each person. This then leads from information to transformation. <Link to={"/principal"}>Read More</Link></p>
                
                    
                    <p style={{fontWeight:"bold"}}>Dr. Jyoti Chhabra 
    Principal  </p></div>
    
    </div>
    <div className='col-lg-4 d-flex mt-5 justify-content-center order-1 order-lg-2'>
                        <img src={Principal} style={{width:"350px", height:"350px"}}  alt="" />
                    </div>
    </div>
<div className="row">


                <div className='col-lg-12 d-flex flex-column justify-content-center mb-4 mb-lg-0'>

            <div className='   container h-100 d-flex flex-column  justify-content-center text-dark'>
                <h3 className=' fw-semibold'>Dear Students,</h3>
                <p className='mb-3'>
                The present of this institution is as glorious as its history. The students have made the institution proud by achieving excellent achievements at national and international levels in all fields. The number of students selected in competitive examinations after studying in the institute is increasing every year, which is a matter of pride.
                  </p>
                <p className='mb-3'>
                Whenever I have made proposals for the progress and investigation of the organization, the management committee has encouraged me by accepting them, for which I am deeply grateful.
                  </p>
                  <p className='mb-3'>
                  Future plans include proposal to publish annual magazine of the institution, to start new departments in the college in the coming session, special classes will be organized to give emphasis on spoken English as per the demand of time and for preparation of competitive examinations. Our special efforts will be on obtaining maximum marks as well as quality education, so that more and more students get selected in various competitive examination and benefit the society. 
                  </p>
                  <p className='mb-3'>
                  These steps of progress of the organization are the result of the faith and blessings expressed in me by the entire staff and management committee. I hope that your will continue to support me in the same way in future as well. 
                  </p><p style={{fontWeight:"bold"}}>Mandeep Singh Sidhu,
Director </p></div>

</div>

</div>

</div>

      
    </div>
  )
}

export default Management;